/*会员管理*/

import {axiospost, axiosget,axiosgetExcel} from './axios';

//会员管理--获取会员列表
export const getAntMembersPage = (params) => axiosget('/sys/membersManagement/getAntMembersPage', params)

// 会员管理--会员分组下拉
export const getOldDeptForSelect = (params) => axiosget('/sys/membersManagement/getOldDeptForSelect', params)

// 会员管理--导出
export const getAntMembersForExcel = (params) => axiosgetExcel('/sys/membersManagement/getAntMembersForExcel', params)

// 会员管理--消费记录
export const getAddPriceAccPage = (params) => axiosget('/sys/membersManagement/getAddPriceAccPage', params)

// 会员管理--添加会员(分组id先放着)
export const addAntMembers = (params) => axiospost('/sys/membersManagement/addAntMembers', params)

// 会员管理--通过门店获取教练
export const getUserForSelect = (params) => axiosget('/sys/businessManage/getCoachListForSelect', params)


// 企业管理--教练和店长下拉列表
export const getCoachListForSelect = (params) => axiosget('/sys/businessManage/getCoachListForSelect', params)
